var map = {
	"./Bulldozer-Tap-01.webp": 7206,
	"./ConstructionEducationBackground.webp": 6718,
	"./Dumptruck-Tap-01.webp": 1974,
	"./EducationBackground.webp": 1617,
	"./EducationBackground5.webp": 4672,
	"./Excavator-Tap-12.webp": 850,
	"./Excavator-Tap-Landing.webp": 5816,
	"./FooterBackground.webp": 3870,
	"./GenAI/GenAI-img-1.png": 9418,
	"./GenAI/GenAI-img-10.png": 9552,
	"./GenAI/GenAI-img-11.png": 4025,
	"./GenAI/GenAI-img-12.png": 3058,
	"./GenAI/GenAI-img-13.png": 7883,
	"./GenAI/GenAI-img-14.png": 4020,
	"./GenAI/GenAI-img-15.png": 7917,
	"./GenAI/GenAI-img-16.png": 3942,
	"./GenAI/GenAI-img-17.png": 879,
	"./GenAI/GenAI-img-18.png": 1032,
	"./GenAI/GenAI-img-19.png": 1249,
	"./GenAI/GenAI-img-2.png": 529,
	"./GenAI/GenAI-img-20.png": 1413,
	"./GenAI/GenAI-img-21.png": 5500,
	"./GenAI/GenAI-img-22.png": 3079,
	"./GenAI/GenAI-img-23.png": 3582,
	"./GenAI/GenAI-img-24.png": 2065,
	"./GenAI/GenAI-img-25.png": 936,
	"./GenAI/GenAI-img-26.png": 2899,
	"./GenAI/GenAI-img-27.png": 986,
	"./GenAI/GenAI-img-28.png": 1757,
	"./GenAI/GenAI-img-29.png": 628,
	"./GenAI/GenAI-img-3.png": 6664,
	"./GenAI/GenAI-img-30.png": 9402,
	"./GenAI/GenAI-img-31.png": 6979,
	"./GenAI/GenAI-img-32.png": 1704,
	"./GenAI/GenAI-img-33.png": 9569,
	"./GenAI/GenAI-img-34.png": 8558,
	"./GenAI/GenAI-img-35.png": 6871,
	"./GenAI/GenAI-img-36.png": 6812,
	"./GenAI/GenAI-img-37.png": 5909,
	"./GenAI/GenAI-img-38.png": 6754,
	"./GenAI/GenAI-img-39.png": 971,
	"./GenAI/GenAI-img-4.png": 6279,
	"./GenAI/GenAI-img-40.png": 6535,
	"./GenAI/GenAI-img-5.png": 7438,
	"./GenAI/GenAI-img-6.png": 9541,
	"./GenAI/GenAI-img-7.png": 7276,
	"./GenAI/GenAI-img-8.png": 7163,
	"./GenAI/GenAI-img-9.png": 2338,
	"./Landing.webp": 6092,
	"./LandingBackground.webp": 4712,
	"./PeriodicTableBackground.webp": 2132,
	"./PeriodicTableMaterials/Adhesive.webp": 5984,
	"./PeriodicTableMaterials/Aluminum.webp": 4281,
	"./PeriodicTableMaterials/Concrete.webp": 9200,
	"./PeriodicTableMaterials/ConcreteAdmixture.webp": 2851,
	"./PeriodicTableMaterials/Copper.webp": 9578,
	"./PeriodicTableMaterials/Drywall.webp": 6784,
	"./PeriodicTableMaterials/Insulation.webp": 9609,
	"./PeriodicTableMaterials/Masonry.webp": 3046,
	"./PeriodicTableMaterials/Paint.webp": 8813,
	"./PeriodicTableMaterials/Solvent.webp": 7236,
	"./PeriodicTableMaterials/Steel.webp": 934,
	"./PeriodicTableMaterials/Tile.webp": 5151,
	"./PeriodicTableMaterials/VinylFlooring.webp": 3615,
	"./PeriodicTableMaterials/Wood.webp": 5006,
	"./PersonalPortfolio/port-img (1).jpg": 449,
	"./PersonalPortfolio/port-img (10).jpg": 2787,
	"./PersonalPortfolio/port-img (11).jpg": 9824,
	"./PersonalPortfolio/port-img (12).jpg": 5833,
	"./PersonalPortfolio/port-img (13).jpg": 6798,
	"./PersonalPortfolio/port-img (14).jpg": 7063,
	"./PersonalPortfolio/port-img (15).jpg": 8116,
	"./PersonalPortfolio/port-img (16).jpg": 9005,
	"./PersonalPortfolio/port-img (17).jpg": 6226,
	"./PersonalPortfolio/port-img (18).jpg": 1243,
	"./PersonalPortfolio/port-img (19).jpg": 3896,
	"./PersonalPortfolio/port-img (2).jpg": 424,
	"./PersonalPortfolio/port-img (20).jpg": 8668,
	"./PersonalPortfolio/port-img (21).jpg": 399,
	"./PersonalPortfolio/port-img (22).jpg": 7802,
	"./PersonalPortfolio/port-img (23).jpg": 1234,
	"./PersonalPortfolio/port-img (24).jpg": 4280,
	"./PersonalPortfolio/port-img (25).jpg": 9963,
	"./PersonalPortfolio/port-img (26).jpg": 8070,
	"./PersonalPortfolio/port-img (27).jpg": 1425,
	"./PersonalPortfolio/port-img (28).jpg": 8004,
	"./PersonalPortfolio/port-img (29).jpg": 551,
	"./PersonalPortfolio/port-img (3).jpg": 9131,
	"./PersonalPortfolio/port-img (30).jpg": 369,
	"./PersonalPortfolio/port-img (31).jpg": 8854,
	"./PersonalPortfolio/port-img (32).jpg": 2859,
	"./PersonalPortfolio/port-img (33).jpg": 376,
	"./PersonalPortfolio/port-img (34).jpg": 1093,
	"./PersonalPortfolio/port-img (35).jpg": 7082,
	"./PersonalPortfolio/port-img (36).jpg": 3407,
	"./PersonalPortfolio/port-img (37).jpg": 3420,
	"./PersonalPortfolio/port-img (38).jpg": 9673,
	"./PersonalPortfolio/port-img (39).jpg": 9022,
	"./PersonalPortfolio/port-img (4).jpg": 4298,
	"./PersonalPortfolio/port-img (40).jpg": 8970,
	"./PersonalPortfolio/port-img (41).jpg": 2981,
	"./PersonalPortfolio/port-img (42).jpg": 5308,
	"./PersonalPortfolio/port-img (43).jpg": 8943,
	"./PersonalPortfolio/port-img (44).jpg": 742,
	"./PersonalPortfolio/port-img (45).jpg": 2257,
	"./PersonalPortfolio/port-img (46).jpg": 5912,
	"./PersonalPortfolio/port-img (47).jpg": 8395,
	"./PersonalPortfolio/port-img (48).jpg": 5650,
	"./PersonalPortfolio/port-img (49).jpg": 4877,
	"./PersonalPortfolio/port-img (5).jpg": 1701,
	"./PersonalPortfolio/port-img (50).jpg": 5903,
	"./PersonalPortfolio/port-img (51).jpg": 6588,
	"./PersonalPortfolio/port-img (52).jpg": 149,
	"./PersonalPortfolio/port-img (6).jpg": 364,
	"./PersonalPortfolio/port-img (7).jpg": 3247,
	"./PersonalPortfolio/port-img (8).jpg": 2062,
	"./PersonalPortfolio/port-img (9).jpg": 6985,
	"./PortfolioCollectionThumbnails/AI-Integration.png": 38,
	"./PortfolioCollectionThumbnails/Commercial Buildings.png": 356,
	"./PortfolioCollectionThumbnails/ConstructionTechnology.png": 7732,
	"./PortfolioCollectionThumbnails/DataAnalytics.png": 4141,
	"./PortfolioCollectionThumbnails/Earthwork.png": 5570,
	"./PortfolioCollectionThumbnails/FleetManagement.png": 7804,
	"./PortfolioCollectionThumbnails/FleetManagement2.png": 3828,
	"./PortfolioCollectionThumbnails/GenerativeAI.png": 9097,
	"./PortfolioCollectionThumbnails/JobsiteTools.png": 8016,
	"./PortfolioCollectionThumbnails/JobsiteTools2.png": 6896,
	"./PortfolioCollectionThumbnails/MultifamilyCommunities.png": 939,
	"./PortfolioCollectionThumbnails/PersonalCollection.png": 4957,
	"./PortfolioCollectionThumbnails/ProjectManagement.png": 9059,
	"./PortfolioCollectionThumbnails/ProjectManagement2.png": 6617,
	"./PortfolioCollectionThumbnails/SafetyCompliance.png": 3546,
	"./PortfolioCollectionThumbnails/SoftwareSolutions.png": 8444,
	"./ScaryBigConstruction.webp": 4954,
	"./ServicesBackground.webp": 4321,
	"./TAP-Logo.webp": 1022,
	"./test-img-01.webp": 7565
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;